import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Link } from "react-router-dom";

export const Header = styled.header`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px); /* Safari support */
  padding: 0 ${(props) => props.theme.spacing.lg};
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
  transition: all 0.3s ease;
  height: 100px;
`;

export const Logo = styled.div`
  color: ${(props) => props.theme.colors.text};
  margin: 0;
  margin-top: 10px;
  font-size: 1.5rem;
  font-weight: 700;
  img {
    height: 60px;
  }

  @media (max-width: 768px) {
    img {
      height: 40px;
    }
  }
`;

export const Nav = styled.nav`
  display: flex;
  gap: ${(props) => props.theme.spacing.lg};
`;

export const NavLink = styled(Link)<{ noAnimation?: boolean }>`
  color: #ccc;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.5rem;
  transition: opacity 0.2s ease;
  position: relative;
  text-shadow: 0px -1px 0px #000, 0px 1px 0px #eee;

  ${({ noAnimation }) =>
    !noAnimation &&
    css`
      &:hover {
        opacity: 0.8;
      }
    `}

  &::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background: ${(props) => props.theme.colors.tertiary};
    transition: width 0.3s ease;
  }

  ${({ noAnimation }) =>
    !noAnimation &&
    css`
      &:hover::after {
        width: 100%;
      }
    `}

  &.active {
    color: #fff;
    text-shadow: 0px 1px 0px #000, 0px -1px 0px #eee;
    &::after {
      width: 100%;
    }
  }
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;
